import { useTranslation } from 'next-i18next';
import { useTheme } from '@forma/forma-ui-theme';
import { Table, TableCell, TableRow } from '@forma/forma-ui-kit';
import formatPrice from '@/helpers/formatPrice';

import { ITariffItem } from '@/helpers/interfaces/tariffs.interface';

import styles from './partnership-table.module.css';

const usersMax: Record<string, number> = {
  tariff_start: 1,
  tariff_team: 6,
  tariff_enterprise: 99,
};

interface PartnershipTableProps {
  tariffs: ITariffItem[];
  debtPercent: number;
}

const PartnershipTable = ({ tariffs, debtPercent }: PartnershipTableProps) => {
  const { t } = useTranslation();
  const { currencies } = useTheme();
  const currency = currencies.ru;

  return (
    <div>
      <Table
        className={styles.table}
        columns={[
          { children: 'Тариф' },
          { children: 'Месяц' },
          { children: 'Стоимость' },
          { children: 'Условия' },
          { children: <span className={styles.rewardLabel}>Вознаграждение</span> },
        ]}
      >
        {tariffs.map(({ id, patterns, name }) => (
          patterns.map(({ duration, price, canChoose, userPrice }) => {
            if (!canChoose) return null;
            const priceMax = (userPrice && usersMax[id]) ? price + userPrice * usersMax[id] : 0;
            const totalMin = price / 100 * debtPercent;
            const totalMax = priceMax ? priceMax / 100 * debtPercent : 0;
            return (
              <TableRow key={`${id}.${duration}`}>
                <TableCell>
                  {name}
                </TableCell>
                <TableCell>
                  {duration / 30}
                </TableCell>
                <TableCell>
                  {!!priceMax && t('from')} {formatPrice(price, currency)} {!!priceMax && t('to')} {!!priceMax && formatPrice(priceMax, currency)}
                </TableCell>
                <TableCell>
                  {debtPercent}% рекуррентно*
                </TableCell>
                <TableCell className={styles.rewardValue}>
                  {!!totalMax && t('from')} {formatPrice(totalMin, currency)}
                  {' '} {!!totalMax && <span>{t('to')} {!!totalMax && formatPrice(totalMax, currency)}</span>}
                </TableCell>
              </TableRow>
            );
          })
        ))}
      </Table>
      <div className={styles.notice}>
        * Рекуррентные выплаты {debtPercent}% до тех пор, пока клиент активен. Закрепление клиента за партнером аннулируется в случае отсутствия оплат в течение 90 дней подряд.
      </div>
    </div>
  );
};

export default PartnershipTable;
